import React from "react";
import { LabeledText, Stack, SuccessMessage } from "sprint-common-web";

import { AccessKey } from "../useGenerateAccessKeyPage";

interface AccessKeyInfoStack {
    bucketName: string;
    accessKeyInfo: AccessKey;
}

export const AccessKeyInfo: React.VFC<AccessKeyInfoStack> = ({ bucketName, accessKeyInfo }: AccessKeyInfoStack) => {
    return (
        <Stack tokens={{ childrenGap: 20 }}>
            <SuccessMessage message="Key succesfully generated. Make sure you copy all values provided as they cannot be retrieved again."></SuccessMessage>
            <Stack>
                <LabeledText label="Bucket arn" value={`arn:aws:s3:::${bucketName}`} />
                <LabeledText label="Access key id" value={accessKeyInfo.accessKeyId} />
                <LabeledText label="Secret access key" value={accessKeyInfo.secretAccessKey} />
            </Stack>
        </Stack>
    );
};
